import React from 'react';
import './About.css';

const About: React.FC = () => {
  return (
    <div className="about-page">
      <div className="content-card">
        <h1>About</h1>
        <p>AEuromotive, Inc.</p>
        <p>
          AEuromotive Inc has over 60 years of experience in the professional automotive industry. Since its
          inception the knowledge that has been pulled together over the years has ranged from work at European
          to Domestic and Asian arenas. As well as Teaching and Field training Professional Technicians and
          managing them. These experiences are derived from the personal training and experiences of Angelo
          Campana and Peter Reese the owners of AEuromotive.
        </p>
        <p>
          Angelo has been helping other shops and Technicians with their Diagnostic Issues since the 1990’s,
          using iATN and a few Forums that were in place. During this time we’ve adapted a teaching and training
          structure for AEuromotive that has carried us on this journey.
        </p>
        <ul>
          <li>Know the Systems on that vehicle</li>
          <li>
            There is NEVER a time that you will know it all. Our Profession and the complexity of the vehicles we
            work on change, EVERY 6 Months!
          </li>
          <li>
            Have a STRONG understanding of the Electronics, every nut and bolt, and their Operation within that
            vehicle
          </li>
          <li>DO NOT throw Parts at Cars!! (I am quite obsessed about NOT DOING that!)</li>
          <li>Information is KING in this Profession</li>
          <li>TIME is $$$$$ in this Profession</li>
          <li>Confidence in YOURSELF, not others to do the JOB!</li>
          <li>ALWAYS count on YOURSELF to do the job RIGHT the FIRST Time.</li>
          <li>
            Never ask any of your Employees to do the JOB that you could not do better yourself (Which means
            TRAINING them to do it RIGHT the FIRST Time)
          </li>
          <li>Leadership at the Front, is what makes for a GREAT Team</li>
          <li>
            Communication to the Customer about the procedures. Which means that you need to know it
          </li>
          <li>
            If you “Talk the Talk…..you BETTER Walk the Walk” As we use to say in the military.
          </li>
          <li>
            Most of all, have the resources to back up your Diagnostics, Plan of Action, and Repairs to be made
          </li>
        </ul>
        <p>Angelo Campana</p>
        <p>
          Angelo Campana who served his country when he was called and for the better part of his Automotive
          Professional career, he has spent a great deal of time moving from one European Car line to another all
          the while gaining the needed knowledge and wisdom of the systems, and knowing the vehicle itself. And
          since 1970, this has been a passion of his. Angelo since a young age of 15 with curiosity of “what made
          things tick” has always had the mechanical inquisitiveness and talents in order get a job done. Over the
          years I’ve majored in Mechanical Engineering, with a minor in History, Linguistics and English
          Literature. Angelo pulls from his experience as well when he worked as a line mechanic, Oil Rigger and
          Drill Mechanic, Marine Application, Engine and Transmission re-manufacturing, Body and Paint, Welding
          and Fabrication, Electronic Devices and Electronics and Design, A training teacher for Baum Tools as
          well as in the training field under Euro-Diagnostic Resources and Automotive, Inc. This in turn sparked
          my ultimate path of AEuromotive and its inception.
        </p>
        <p>Peter Reese</p>
        <p>
          Peter Reese’s 30+ years in the Professional Automotive Industry &amp; Business, include work at European,
          Domestic and Asian Dealerships, and instruction of college-level courses in Automotive Technology. As an
          ASE Master Technician and Audi Master Technician, Peter Reese has served as CEO of{' '}
          <a href="http://diagnostichotline.com/" target="_blank" rel="noopener noreferrer">
            Diagnostic Hotline
          </a>{' '}
          since 2001.{' '}
          <a href="http://diagnostichotline.com/" target="_blank" rel="noopener noreferrer">
            Diagnostic Hotline
          </a>{' '}
          is a FULL Service Automotive Technical Assistance Hotline for the repair of all passenger cars and
          trucks serviced in the United States and Canada. Staffed by the highest quality technicians across the
          country, it is a leading{' '}
          <a href="http://diagnostichotline.com/" target="_blank" rel="noopener noreferrer">
            Diagnostic Hotline
          </a>{' '}
          in North America.
        </p>
      </div>
    </div>
  );
};

export default About;

